import { HistoryEntry } from './types';

// Previous versions may have recorded incomplete history, make sure
// the history we're using matches current expectations
export function cleanHistory(history: unknown): HistoryEntry[] {
  if (!Array.isArray(history)) {
    return [];
  }

  // Arbitrary date for old entries missing timestamps
  const defaultTimestamp = new Date(2018, 1, 7).getTime();

  return history
    .map((entry) => {
      return {
        count: 1,
        timestamp: defaultTimestamp,
        ...entry,
      };
    })
    .filter((entry: Partial<HistoryEntry>): entry is HistoryEntry => {
      return (
        entry.action !== undefined &&
        entry.context !== undefined &&
        entry.count !== undefined &&
        entry.timestamp !== undefined
      );
    });
}
